/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const ProcessDetailPage = lazyLoad(
  () => import('./index'),
  module => module.ProcessDetailPage
);
